<template>
  <div class="home"
       :class="langFlag ?'enPage':'chPage'">
    <div :class="bgFlag?'tarnsf':''">
      <div class="hheader"
           :class="moveFlag?'bgColor':''">
        <h1 class="ihed_h1"
            @click="toHome()">
          <img src="~@/assets/images/svg/logo_top_white.svg"
               v-show="!bgFlag"
               class="logo_pic" />
          <img src="~@/assets/image/svg/Top Logo_black.svg"
               class="logo_pic"
               v-show="bgFlag" />
        </h1>
        <div class="herg">
          <span class="herg_lang"
                @click='changeLang()'>{{lang}}</span>
          <i class="herg_mu"
             @click="nuneClick(1)"></i>
        </div>
      </div>
    </div>
    <div class="workBan">
      <div class="workBan_bg"
           :style="'background-image:url(' + backgroundImage +')'"></div>
      <!-- <i class="uparr"></i> -->
      <!-- <img src="~@/assets/images/zp/zp_banner.jpg"
           class="zp_banner" /> -->
      <div class="wkInn">
        <p class="wkInn_p1 fontS">{{detailInfo.title}}</p>
        <p class="wkInn_p2">{{detailInfo.location}}, {{detailInfo.year}}</p>
      </div>
    </div>
    <div class="workbd">
      <div v-html="detailInfo.desp"></div>

      <!-- <gotop></gotop> -->
      <div class="pageList">
        <div class="page_per"
             @click="per()">
          <img src="~@/assets/images/svg/previous_project_arrow.svg"
               class="per_pic"
               v-show="prevId" />
          <span class="per_na"
                v-show="prevId">上一案例</span>
        </div>
        <div class="page_next"
             @click="next()">
          <span class="per_na"
                v-show="nextId">下一案例</span>
          <img src="~@/assets/images/svg/next_project_arrow.svg"
               class="next_pic"
               v-show="nextId" />
        </div>
      </div>
    </div>

    <!-- TODO -->
    <!-- <div class="workbd"> -->
    <!-- <div class="workItem clearfix">
        <div class="wk_lf">
          <p class="wk_lf_p1">隐藏的古县城‒宁波慈城</p>
          <p class="wk_lf_p2">在1600㎡的空间中，将酒店大堂的功能空间弱化，释放空间更多的
            可能性。材料上，采用木纹石和金属；造型上，加入人字形天花板形态，
            以简单符号留给空间及空间使用者亲切熟悉之感，让酒店空间与家
            空间的界限感变得模糊。</p>
        </div>
        <div class="wk_rg">
          <img src="~@/assets/images/zp/wk_pic1.jpg"
               class="wk_pic1" />
        </div>
      </div> -->
    <!-- swier begin -->
    <!-- <div class="wksi">
        <div class="jourSwi">
          <div class="swiper-container jour_swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="~@/assets/images/zp/sw_pic1.jpg"
                     class="timage_img" />
              </div>
              <div class="swiper-slide">
                <img src="~@/assets/images/zp/sw_pic1.jpg"
                     class="timage_img" />
              </div>
              <div class="swiper-slide">
                <img src="~@/assets/images/zp/sw_pic1.jpg"
                     class="timage_img" />
              </div>
            </div> -->
    <!-- 如果需要分页器 -->
    <!-- <div class="swiper-pagination"></div> -->

    <!-- 如果需要导航按钮 -->
    <!-- <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>
      </div> -->

    <!-- swier end -->
    <!-- <div class="wkflt">
        <div class="wlflt_lf">
          <img src="~@/assets/images/zp/wk_pic2.jpg"
               class="wk_pic2" />
        </div>
        <div class="wlflt_rg">
          <img src="~@/assets/images/zp/wk_pic3.jpg"
               class="wk_pic3" />
        </div>
      </div>
      <div class="wkflft clearfix">
        <div class="wkflft_lf">
          <p class="wk_lf_p1">光阴的故事</p>
          <p class="wk_lf_p2">项目通过设计将远行的旅人、来公园游玩的路人，以及居住在此处的邻里
            相联，强化三者对空间高度重叠和互补的共同需求。在形态上，让室内外
            得到更大流动的开放空间，塑造出“城市客厅”的亲切姿态。</p>
          <p class="wk_lf_p2">在1600㎡的空间中，将酒店大堂的功能空间弱化，释放空间更多的可能
            性。材料上，采用木纹石和金属；造型上，加入人字形天花板形态，以简单
            符号留给空间及空间使用者亲切熟悉之感，让酒店空间与家空间的界限
            感变得模糊。</p>
        </div>
        <div class="wkflft_rg">
          <img src="~@/assets/images/zp/wk_pic4.jpg"
               class="wk_pic4" />
        </div>
      </div>
      <div class="wkffive clearfix">
        <div class="wkffive_lf">
          <img src="~@/assets/images/zp/wk_pic5.jpg"
               class="wk_pic5" />
        </div>
        <div class="wkffive_rg">
          <img src="~@/assets/images/zp/wk_pic6.jpg"
               class="wk_pic6" />
        </div>
      </div>
      <div class="wfssev clearfix">
        <img src="~@/assets/images/zp/wk_pic7.jpg"
             class="wk_pic7" />
      </div>
      <div class="wkmsz">
        <p class="wkmsz_p1">“赋予室内外空间更大的流动可能性，以一个城市客厅的姿态，
          即使路过的人也乐于在此驻足休憩。”</p>
        <p class="wkmsz_p2">— 陈亨寰 ，主案设计师</p>
      </div>
      <div class="csget clearfix">
        <div class="csget_lf">
          <img src="~@/assets/images/zp/wk_pic8.jpg"
               class="wk_pic8" />
          <p class="cast_p">天一阁, 戏台长廊戏台，建立于1561</p>
        </div>
        <div class="csget_rg">
          <p></p>
          <p class="wk_lf_p1">天一阁<br>最早的私家藏书楼</p>
          <p class="wk_lf_p2">在1600㎡的空间中，将酒店大堂的功能空间弱化，释放空间更多的
            可能性。材料上，采用木纹石和金属；造型上，加入人字形天花板形态，
            以简单符号留给空间及空间使用者亲切熟悉之感，让酒店空间与家
            空间的界限感变得模糊。天一阁位于浙江省宁波市海曙区，是中国现存最早的私家藏书楼，也是亚
            洲现有最古老的图书馆和世界最早的三大家族图书馆之一。建于明朝中
            期，由当时退隐的明朝兵部右侍郎范钦主持建造，占地面积2.6万平方米，
            已有400多年的历史，是中国藏书文化的代表之作。1982年被国务院公布
            为全国重点文物保护单位</p>
        </div>
      </div>
      <div class="wkdzk">
        <div class="wkdzk_inner">
          <img src="~@/assets/images/zp/wk_pic9.jpg"
               class="wk_pic9" />
          <p class="wkdzk_p">明式家具 宝座式禅椅 1378–1644</p>
        </div>
        <div class="wkdzk_out">
          <img src="~@/assets/images/zp/wk_pic10.jpg"
               class="wk_pic10" />
        </div>
      </div>
      <div class="wkdfj">
        <img src="~@/assets/images/zp/wk_pic11.jpg"
             class="wk_pic11" />
      </div>
      <div class="wkedn clearfix">
        <img src="~@/assets/images/zp/wk_pic12.jpg"
             class="wk_pic12" />
        <img src="~@/assets/images/zp/wk_pic13.jpg"
             class="wk_pic13" />
      </div>
      <div class="pmts clearfix">
        <div class="pmts_inner clearfix">
          <div class="pmts_lf">
            <img src="~@/assets/images/zp/wk_pic14.jpg"
                 class="wk_pic14" />
          </div>
          <div class="pmts_rg">
            <p class="pmts_p1">平面配置图</p>
            <p class="pmts_p2">天一阁位于浙江省宁波市海曙区，是中国现存最早的私家藏书楼，也是亚
              洲现有最古老的图书馆和世界最早的三大家族图书馆之一。建于明朝中
              期，由当时退隐的明朝兵部右侍郎范钦主持建造，占地面积2.6万平方米，
              已有400多年的历史，是中国藏书文化的代表之作。1982年被国务院公布
              为全国重点文物保护单位</p>
          </div>
        </div>
        <div class="pmts_bt">
          <div class="pmts_li">
            <p class="pmts_li_p1">空間面積</p>
            <p class="pmts_li_p2">16000m2</p>
          </div>
          <div class="pmts_li">
            <p class="pmts_li_p1">座落位置</p>
            <p class="pmts_li_p2">宁波 中国</p>
          </div>
          <div class="pmts_li">
            <p class="pmts_li_p1">开发商</p>
            <p class="pmts_li_p2">宁波江山万里置业有限公司</p>
          </div>
          <div class="pmts_li">
            <p class="pmts_li_p1">获奖记录</p>
            <div class="hjji">
              <img src="~@/assets/images/zp/wk_pic15.jpg"
                   class="wk_pic15" />
            </div>
          </div>
        </div>

      </div>
      <gotop></gotop> -->
    <!-- </div> -->
    <!-- footer -->
    <div class="wkft">
      <foot @contact="contact"></foot>
    </div>
    <transition name="slide-fade">
      <munePage v-show="muneFlag"
                :muneFlag="muneFlag"
                :muneIndex="muneIndex"
                @closeMu="closeMu"
                @muneChange='muneIndexChange'></munePage>
    </transition>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import foot from '@/components/foot.vue'
import gotop from '@/components/goTop.vue'
import munePage from '@/pages/munePage.vue'
import { mapMutations, mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      bgFlag: false,
      muneFlag: false,
      muneIndex: -1,
      mySwiper: null,
      img1: require('@/assets/images/home/hm_banner.jpg'),
      moveFlag: false,
      detailId: '',
      title: '',
      des: '',
      detailInfo: {},
      backgroundImage: '',
      // backgroundImage: 'url(' + require('@/assets/images/ab_img1.jpg') + ')',
      nextId: 0,
      prevId: 0,
    }
  },
  components: { foot, gotop, munePage },
  mounted() {
    this.detailId = this.$route.query.detailId || ''
    let that = this
    this.projectInfo()

    // 滚动条滚动
    window.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapState(['langFlag', 'lang']),
  },
  watch: {
    langFlag(val) {
      console.log('中英文的值', val)
      this.projectInfo()
    },
  },
  methods: {
    // 菜单
    nuneClick(index) {
      this.muneFlag = true
      this.muneIndex = 1
    },
    closeMu() {
      this.muneFlag = false
    },
    contact() {
      this.muneFlag = true
      this.muneIndex = 3
    },
    muneIndexChange(index) {
      this.muneIndex = index
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var winH =
        document.documentElement.clientHeight || document.body.clientHeight
      var scroll = scrollTop - this.i
      this.i = scrollTop
      if (scroll <= 0) {
        this.moveFlag = false
      } else {
        this.moveFlag = true
      }
      if (scrollTop < winH) {
        this.bgFlag = false
      } else {
        this.bgFlag = true
      }

      // let t1 = document.documentElement.scrollTop || document.body.scrollTop
      // if (t1 > 10) {
      //   this.moveFlag = true
      // } else {
      //   this.moveFlag = false
      // }
    },
    //切换语言
    changeLang() {
      // this.SET_WFFLAG(true)
      console.log('语言1', this.langFlag)
      this.$store.commit('setLang', !this.langFlag)
      this.$store.commit('setLa', this.lang == 'EN' ? 'CH' : 'EN')
      console.log('语言', this.langFlag)
    },
    // 返回首页
    toHome() {
      this.$router.push({
        name: 'home',
        // query: {
        //   type: type,
        // },
      })
    },
    next() {
      this.detailId = this.nextId
      this.$router.push({
        name: 'works',
        query: {
          detailId: this.nextId,
        },
      })
      this.projectInfo()
    },
    per() {
      this.detailId = this.prevId
      this.$router.push({
        name: 'works',
        query: {
          detailId: this.prevId,
        },
      })
      this.projectInfo()
    },
    // 获取产品详情
    projectInfo() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'projectInfo',
        that.$qs.stringify({
          type: type,
          id: that.detailId,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            that.detailInfo = response.data
            that.backgroundImage = response.data.banner
            console.log('ddd')
            document.title = response.data.title
            that.prevId = response.data.prevId
            that.nextId = response.data.nextId
            console.log('sss', that.prevId, that.nextId)
            that.$nextTick(function () {
              that.mySwiper = new Swiper('.jour_swiper', {
                observer: true,
                observeParents: true,
                speed: 1800,
                slidesPerView: 'auto',
                centeredSlides: true,
                loop: true,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                },
                // pagination: {
                //   el: '.swiper-pagination',
                // },
                navigation: {
                  nextEl: '.jour_swiper .swiper-button-next',
                  prevEl: '.jour_swiper .swiper-button-prev',
                },
              })
            })
          }
        })
        .catch(function (error) {})
    },
  },
}
</script>
<style>
</style>





// WEBPACK FOOTER //
// src/pages/works.vue